"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 03 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * OptimizationGoalsSettingsConverter.
 *
 * @author RV
 */


var OptimizationGoalsSettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(OptimizationGoalsSettingsConverter, _DataObjectConverter_);

  function OptimizationGoalsSettingsConverter() {
    _classCallCheck(this, OptimizationGoalsSettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptimizationGoalsSettingsConverter).apply(this, arguments));
  }

  return OptimizationGoalsSettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.OptimizationGoalsSettingsConverter = OptimizationGoalsSettingsConverter;